import { render, staticRenderFns } from "./lang-settings.vue?vue&type=template&id=6e6a0770&"
import script from "./lang-settings.vue?vue&type=script&lang=js&"
export * from "./lang-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports